/** In-memory settings cache — survives route changes until full page reload. */
let cached = null;
let loadPromise = null;

export function getCachedAppSettings() {
  return cached;
}

export function setCachedAppSettings(settings) {
  if (!settings || typeof settings !== "object") return;
  cached = {
    customCss: settings.customCss || "",
    customJs: settings.customJs || "",
  };
}

export function isSettingsCacheReady() {
  return cached != null;
}

export function getSettingsLoadPromise() {
  return loadPromise;
}

export function setSettingsLoadPromise(promise) {
  loadPromise = promise;
}

export function clearSettingsLoadPromise() {
  loadPromise = null;
}

export function invalidateSettingsCache() {
  cached = null;
  loadPromise = null;
}
